import { ref, computed, onMounted, onUnmounted } from "vue";
import moment from "@/services/moment";

export function useCurrentTime() {
  const currentTimestamp = ref(Date.now());
  let timerId = null;

  const currentYear = computed(() =>
    moment(currentTimestamp.value).format("YYYY")
  );
  const currentDateTimeWithoutYear = computed(() =>
    moment(currentTimestamp.value).format("MM.DD HH:mm:ss")
  );

  onMounted(() => {
    timerId = setInterval(() => {
      currentTimestamp.value = Date.now();
    }, 1000);
  });

  onUnmounted(() => {
    clearInterval(timerId);
  });

  return { currentYear, currentDateTimeWithoutYear };
}
